export default "__VITE_ASSET__B0WRc3kF__"